import { Link } from "react-router-dom";

const latamCities = [
  { name: "Ciudad de México", slug: "ciudad-de-mexico" },
  { name: "Buenos Aires", slug: "buenos-aires" },
  { name: "Bogotá", slug: "bogota" },
  { name: "Lima", slug: "lima" },
  { name: "Santiago", slug: "santiago" },
  { name: "Monterrey", slug: "monterrey" },
  { name: "Medellín", slug: "medellin" },
  { name: "Guadalajara", slug: "guadalajara" },
  { name: "Caracas", slug: "caracas" },
  { name: "Quito", slug: "quito" },
];

export const FooterLatamCities = () => {
  return (
    <div>
      <h4 className="font-semibold mb-4">Ciudades Latinoamérica</h4>
      <ul className="space-y-2 text-sm">
        {latamCities.map((city) => (
          <li key={city.slug}>
            <Link
              to={`/ciudad/${city.slug}`}
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              {city.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
